import { render, staticRenderFns } from "./reportOweFeeDetailList.vue?vue&type=template&id=556bbc54&scoped=true"
import script from "./reportOweFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportOweFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportOweFeeDetailList.vue?vue&type=style&index=0&id=556bbc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556bbc54",
  null
  
)

export default component.exports